import "@ant-design/v5-patch-for-react-19";

import { initializeSessionRecord, sessionRecord } from "@buzzeasy/shared-frontend-utilities/sessionRecording";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { serializeError } from "./utils/miscUtils";

export default function globalSetup(): void {
  dayjs.extend(updateLocale);
  tryPreventTabSleepWithWebLock();

  initializeSessionRecord();
  sessionRecord.startRecording({
    html: false,
    mouseMoves: false,
    mouseClicks: true,
    console: true,
    network: true,
  });

  window.addEventListener("error", e => sessionRecord.recordCustomEvent("error/uncaught", {
    message: e.message,
    source: e.filename,
    line: e.lineno,
    column: e.colno,
    error: serializeError(e.error), // null for cross-origin scripts ("Script error.")
  }));

  window.addEventListener("unhandledrejection", e => sessionRecord.recordCustomEvent("error/unhandledrejection", {
    reason: serializeError(e.reason),
  }));

  window.addEventListener("securitypolicyviolation", e => sessionRecord.recordCustomEvent("error/securitypolicyviolation", {
    blockedURI: e.blockedURI,
    directive: e.effectiveDirective,
    disposition: e.disposition, // "enforce" or "report"
    source: e.sourceFile,
    line: e.lineNumber,
    column: e.columnNumber,
    sample: e.sample,
  }));

  window.addEventListener("online", () => sessionRecord.recordCustomEvent("network/connection-status", { online: true }));
  window.addEventListener("offline", () => sessionRecord.recordCustomEvent("network/connection-status", { online: false }));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let lockResolver: unknown;

function tryPreventTabSleepWithWebLock() {
  if (navigator && navigator.locks && navigator.locks.request) {
    const promise = new Promise((res) => { lockResolver = res; });
    void navigator.locks.request("sleep-preventer-lock", { mode: "shared" }, () => promise);

    // eslint-disable-next-line no-console
    console.log("Web Locks API supported, tab sleep prevention enabled.");
  }
  else {
    // eslint-disable-next-line no-console
    console.log("Web Locks API not supported, tab sleep prevention disabled.");
  }
}
